module.exports = __webpack_public_path__ + "img/symbol_6.e969be0f.png";